import $ from 'jquery';
import Swiper from 'swiper/bundle';

const initializeBlock = function ($block) {
    new Swiper($block.find('.blog-block__slider')[0], {
        slidesPerView: 1,
        spaceBetween: 30,
        watchOverflow: true,
        navigation: {
            nextEl: '.blog-block__nav--next',
            prevEl: '.blog-block__nav--prev',
        },
        breakpoints: {
            576: {
                slidesPerView: 1.2,
            },
            992: {
                slidesPerView: 2,
            },
        },
    });
};

$('.blog-block').each(function () {
    initializeBlock($(this));
});

if (window.acf) {
    window.acf.addAction(
        'render_block_preview/type=gral-blog',
        initializeBlock
    );
}
